import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Core.
import { ITaxonomyTerm, TAXONOMY_FOOTER_ID, useAppDispatch } from 'core';

// Store.
import { getTaxonomyTermById } from 'store/taxonomy/actions';
import { footerTermsSelector } from 'store/taxonomy/selectors';

export const useTaxonomyFooter = (): ITaxonomyTerm[] => {
  const dispatch = useAppDispatch();
  const footer = useSelector(footerTermsSelector);

  useEffect(() => {
    dispatch(getTaxonomyTermById(TAXONOMY_FOOTER_ID));
  }, [dispatch]);

  return footer;
};
